// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__tjixH","tabs__list":"styles_tabs__list__rl_Mf"};